import { createAction } from '@saucelabs/sl-util-redux';

import * as constants from './types';

export const handleChangePagination = createAction(constants.CHANGE_PAGINATION);
